export const DIVIDER = 'divider';
export const DROPDOWN = 'dropdown';
export const MARKDOWN = 'markdown';
export const TEXT = 'text';
export const TEXTAREA = 'textarea';
export const TOGGLE = 'toggle';
export const CUSTOM = 'custom';
